import {
  Box,
  Typography
} from '@mui/material'
import { keyframes } from '@mui/system'
import { useEffect } from 'react'
import useKeyPress from 'src/hooks/useKeyPress'
import OptionButton from './common/OptionButton'

import loadingGif from 'src/assets/gif/loading.gif'
import Subtitle from './common/Subtitle'

// gamover screen
const containerStyle = {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  zIndex: 6,
  backgroundColor: 'black'
}

const containerStyleMobile = {
  ...containerStyle,
  margin: 'auto',
  overflow: 'hidden'
}


const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

interface GameOverProps {
  isMobile: boolean
  handleClick: () => void
}


const GameOver = ({ isMobile, handleClick }: GameOverProps) => {
  const keyPressed = useKeyPress('Enter')
  useEffect(() => {
    if (keyPressed) {
      handleClick()
    }
  })

  return (
    <Box sx={isMobile ? containerStyleMobile : containerStyle} onClick={handleClick} className="gameover">
      <Box sx={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <Subtitle color='#c4a26c' backgroundColor='#372237'>You're dead.</Subtitle>
        <Box sx={{marginTop: '32px', transform: 'scale(2)', animation: `${fadeIn} 3s ease-out forwards`}}>
          <OptionButton
            text='Try again'
            color='#c4a26c'
            backgroundColor='#372237'
            borderColor='#372237'
            handleClick={() => { handleClick() }}
          />
        </Box>
      </Box>
      
      <img src={loadingGif} alt='loading' style={{height: '100%', imageRendering: 'pixelated'}}></img>
    </Box>
  )
}

export default GameOver
